const residentialNurse = {
  NURSING: {
    LIST_PATIENT: "LIST_PATIENT_NURSING",
    COME_IN_HOSPITAL_INFO: "COME_IN_HOSPITAL_INFO",
    TREATMENT_INFO: "TREATMENT_INFO",
    COME_OUT_HOSPITAL_INFO: "COME_OUT_HOSPITAL_INFO",
    EXAMINE_HISTORY: "EXAMINE_HISTORY",
    SICK_BED_CATALOG: "SICK_BED_CATALOG",
  },
  TREATMENT: {
    LIST_PATIENT: "LIST_PATIENT_TREATMENT",
    TREATMENT_INFO: "TREATMENT_INFO",
    EXAM_HISTORY: "EXAM_HISTORY_TREATMENT",
    CATALOG: "CATALOG",
  },
  SURGERY: {
    LIST_PATIENT: "LIST_PATIENT_SURGERY",
    INFO_DETAIL: "INFO_DETAIL_SURGERY",
    EXAM_HISTORY: "EXAM_HISTORY_SURGERY",
    ADVANCE_SETTING: "ADVANCE_SETTING",
  },
};

export { residentialNurse };
